import { useEffect, useState } from 'react';
import { CountBoxDiv, CountDownContainer, Dot, HMS, TimerSpan } from './styled';

export default function CountDown(props) {
  const { data, timerOnPdp } = props;
  const endDate = new Date(data?.endTime);

  const calculateTimeLeft = () => {
    const difference = new Date(endDate) - new Date();
    let timeLeft = {};
    if (difference > 0) {
      timeLeft = {
        daysInString: Math.floor(difference / (1000 * 60 * 60 * 24)).toString(),
        hoursInString: Math.floor(
          (difference / (1000 * 60 * 60)) % 24,
        ).toString(),
        minuteInString: Math.floor((difference / 1000 / 60) % 60).toString(),
        secondInString: Math.floor((difference / 1000) % 60).toString(),
      };
      for (const key in timeLeft) {
        if (timeLeft[key].length === 1) timeLeft[key] = '0' + timeLeft[key];
      }
    }
    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
  });
  const { daysInString, hoursInString, minuteInString, secondInString } =
    timeLeft;

  return (
    <CountDownContainer>
      {daysInString > 0 ? (
        <>
          <CountBoxDiv>
            <div>
              <TimerSpan timerOnPdp={timerOnPdp}>{daysInString?.[0]}</TimerSpan>
              <TimerSpan timerOnPdp={timerOnPdp}>{daysInString?.[1]}</TimerSpan>
            </div>
            <HMS>Days</HMS>
          </CountBoxDiv>
          <Dot>:</Dot>
        </>
      ) : null}
      <CountBoxDiv>
        <div>
          <TimerSpan timerOnPdp={timerOnPdp}>{hoursInString?.[0]}</TimerSpan>
          <TimerSpan timerOnPdp={timerOnPdp}>{hoursInString?.[1]}</TimerSpan>
        </div>
        <HMS>HRS</HMS>
      </CountBoxDiv>
      <Dot>:</Dot>
      <CountBoxDiv>
        <div>
          <TimerSpan timerOnPdp={timerOnPdp}>{minuteInString?.[0]}</TimerSpan>
          <TimerSpan timerOnPdp={timerOnPdp}>{minuteInString?.[1]}</TimerSpan>
        </div>
        <HMS>MIN</HMS>
      </CountBoxDiv>
      <Dot>:</Dot>
      {daysInString <= 0 ? (
        <>
          <CountBoxDiv>
            <div>
              <TimerSpan timerOnPdp={timerOnPdp}>
                {secondInString?.[0]}
              </TimerSpan>
              <TimerSpan timerOnPdp={timerOnPdp}>
                {secondInString?.[1]}
              </TimerSpan>
            </div>
            <HMS>SEC</HMS>
          </CountBoxDiv>
        </>
      ) : null}
    </CountDownContainer>
  );
}
